import { render, staticRenderFns } from "./ReferralEmptyPage.vue?vue&type=template&id=5f9201a6&"
import script from "./ReferralEmptyPage.vue?vue&type=script&lang=js&"
export * from "./ReferralEmptyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports